import React from 'react';
import { motion } from 'framer-motion';

const DeveloperPartners = () => {
  const developers = [
    { name: 'Lodha Group', logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop' },
    { name: 'Godrej Properties', logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop' },
    { name: 'Oberoi Realty', logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop' },
    { name: 'Kalpataru Group', logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop' },
    { name: 'Rustomjee', logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop' },
    { name: 'Shapoorji Pallonji', logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop' },
    { name: 'Raheja Developers', logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop' },
    { name: 'Hiranandani Group', logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=200&h=100&fit=crop' },
  ];

  return (
    <section className="py-20 md:py-32 px-6 md:px-12 lg:px-24 bg-background" data-testid="developer-partners-section">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <span className="text-secondary text-sm font-medium tracking-widest uppercase">Trusted Partnerships</span>
          <h2 className="font-playfair text-4xl lg:text-5xl font-bold text-primary mt-4 mb-6 tracking-tight">
            Premier Developer Network
          </h2>
          <p className="text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Strategic alliances with India's most prestigious developers, ensuring access to the finest
            luxury properties and exclusive pre-launch opportunities.
          </p>
        </motion.div>

        {/* Developer Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {developers.map((developer, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              data-testid={`developer-${developer.name.toLowerCase().replace(/\s+/g, '-')}`}
              className="group bg-white p-6 flex items-center justify-center border border-muted hover:border-secondary transition-all duration-500 hover:shadow-[0_4px_20px_-2px_rgba(15,40,30,0.1)] min-h-[120px]"
            >
              {/* Using text instead of logos since we don't have actual logo URLs */}
              <div className="text-center">
                <div className="font-playfair text-base font-semibold text-primary group-hover:text-secondary transition-colors duration-300">
                  {developer.name}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Awards Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-20 text-center"
        >
          <h3 className="font-playfair text-2xl font-semibold text-primary mb-8">
            Recognized Excellence
          </h3>
          <div className="flex flex-wrap justify-center gap-8 items-center">
            <div className="bg-accent p-6 border border-secondary/20 min-w-[200px]" data-testid="award-1">
              <div className="font-playfair text-lg font-semibold text-primary mb-2">Top Channel Partner</div>
              <div className="text-sm text-muted-foreground">Doodle Homes Lonavala</div>
            </div>
            <div className="bg-accent p-6 border border-secondary/20 min-w-[200px]" data-testid="award-2">
              <div className="font-playfair text-lg font-semibold text-primary mb-2">Excellence in Sales</div>
              <div className="text-sm text-muted-foreground">Private Land deal in Khopoli</div>
            </div>
            <div className="bg-accent p-6 border border-secondary/20 min-w-[200px]" data-testid="award-3">
              <div className="font-playfair text-lg font-semibold text-primary mb-2">Platinum Partner</div>
              <div className="text-sm text-muted-foreground">Lodha Group 2023</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DeveloperPartners;
